module.exports = __webpack_public_path__ + "12c3f30015ac9e2b226904fd3140116a.png";